import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@material-ui/core";
import { disable, bussiness, iconTemplateSet, iconTemplateUnset } from '../../../assets/logos/icons'
import {
  GridHLPure,
  InputHLPure,
  ButtonHLPure,
  DialogUserNegotiation,
  CheckBoxHLPure
} from "../../pures";
import AutoCompletePure from "../../pures/autocomplete/AutoCompletePure";
import "./team-negotiation.css";

const TeamNegotiationView = (props) => {
  const { t } = useTranslation();
  let { teamAssigned, createMember, addTeamMember, setError, setMessage } = props
  const [showColaboratorDialog, setShowColaboratorDialog] = useState(false)
  const [showGuestDialog, setShowGuestsDialog] = useState(false)
  const [searchValueColaborator, setSearchValueColaborator] = useState("")
  const [searchValueGuest, setSearchValueGuest] = useState("")
  const [originalArrayColaborator, setOriginalArrayColaborator] = useState([])
  const [filteredArrayColaborator, setFilteredArrayColaborator] = useState([])
  const [originalArrayGuest, setOriginalArrayGuest] = useState([])
  const [filteredArrayGuest, setFilteredArrayGuest] = useState([])
  const [colaboratorsToAdd, setColaboratorsToAdd] = useState([])
  const [guestsToAdd, setGuestsToAdd] = useState([])
  const [errorInEmail, setErrorInEmail] = useState(false)
  const [errorInEmailColaborator, setErrorInEmailColaborator] = useState(false)

  const [openSecondDialogColaborator, setOpenSecondDialogColaborator] = useState(false);

  const [openSecondDialogGuest, setOpenSecondDialogGuest] = useState(false);

  const [guestName, setGuestName] = useState("")
  const [guestLastNames, setGuestLastNames] = useState("")
  const [guestEmail, setGuestEmail] = useState("")

  const [colaboratorName, setColaboratorName] = useState("")
  const [colaboratorLastNames, setColaboratorLastNames] = useState("")
  const [colaboratorEmail, setColaboratorEmail] = useState("")

  const onChangeCheckbox = (e, dataItem) => {
    const { checked } = e.target
    const usersCopy = [...filteredArrayColaborator]
    const usersOriginal = [...originalArrayColaborator]
    const colaboratorsToPush = [...colaboratorsToAdd]
    let targetCopy = [...usersCopy].findIndex(item => item.id === dataItem.id)
    let targetOriginal = [...usersOriginal].findIndex(item => item.id === dataItem.id)

    usersCopy[targetCopy] = {
      ...usersCopy[targetCopy],
      isAssigned: checked
    }

    usersOriginal[targetOriginal] = {
      ...usersOriginal[targetOriginal],
      isAssigned: checked
    }

    if (checked) {
      colaboratorsToPush.push(usersOriginal[targetOriginal])
    } else {
      const pushindex = colaboratorsToPush.findIndex(item => item.id === dataItem.id)
      colaboratorsToPush.splice(pushindex, 1)
    }

    setColaboratorsToAdd(colaboratorsToPush)
    setFilteredArrayColaborator(usersCopy)
    setOriginalArrayColaborator(usersOriginal)
  }

  const onChangeCheckboxGuest = (e, dataItem) => {
    const { checked } = e.target
    const usersCopy = [...filteredArrayGuest]
    const usersOriginal = [...originalArrayGuest]
    const guestsToPush = [...guestsToAdd]

    let targetCopy = [...usersCopy].findIndex(item => item.id === dataItem.id)
    let targetOriginal = [...usersOriginal].findIndex(item => item.id === dataItem.id)

    usersCopy[targetCopy] = {
      ...usersCopy[targetCopy],
      isAssigned: checked
    }

    usersOriginal[targetOriginal] = {
      ...usersOriginal[targetOriginal],
      isAssigned: checked
    }

    if (checked) {
      guestsToPush.push(usersCopy[targetOriginal])
    } else {
      const pushindex = guestsToPush.findIndex(item => item.id === dataItem.id)
      guestsToPush.splice(pushindex, 1)
    }

    if (teamAssigned.contractorsWithGuests.find(item => item.id === 0)) {
      if (guestsToPush.length > 3 || (teamAssigned?.contractorsWithGuests.find(item => item.id === 0).guests.length + guestsToPush.length) > 3) {
        setMessage("Solo se permiten 3 invitados por negociación")
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 2000)
        return
      }
    } else if (teamAssigned?.contractorsWithGuests.find(item => item.id === dataItem.id).guests && teamAssigned?.contractorsWithGuests.find(item => item.id === dataItem.id).guests.length > 0) {
      if (guestsToPush.length > 3 || (teamAssigned?.contractorsWithGuests.find(item => item.id === dataItem.id).guests.length + guestsToPush.length) > 3) {
        setMessage("Solo se permiten 3 invitados por negociación")
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 2000)
        return
      }
    }

    setGuestsToAdd(guestsToPush)
    setFilteredArrayGuest(usersCopy)
    setOriginalArrayGuest(usersOriginal)
  }

  const closeColaboratorDialog = () => {
    setColaboratorsToAdd([])
    setOriginalArrayColaborator([...teamAssigned.ownTeam.possibleCollaborators])
    setFilteredArrayColaborator([...teamAssigned.ownTeam.possibleCollaborators])
    setShowColaboratorDialog(false)
    setSearchValueColaborator("")
    setColaboratorEmail("")
    setColaboratorLastNames("")
    setColaboratorName("")
  }

  const closeGuestsDialog = () => {
    if (teamAssigned?.contractorsWithGuests.find(item => item.id === 0)) {
      setGuestsToAdd([])
      setOriginalArrayGuest([...teamAssigned?.contractorsWithGuests.find(item => item.id === 0).possibleGuests])
      setFilteredArrayGuest([...teamAssigned?.contractorsWithGuests.find(item => item.id === 0).possibleGuests])
      setShowGuestsDialog(false)
      setSearchValueGuest("")
      setGuestName("")
      setGuestEmail("")
      setGuestLastNames("")
    } else {
      setGuestsToAdd([])
      setOriginalArrayGuest([...teamAssigned?.contractorsWithGuests])
      setFilteredArrayGuest([...teamAssigned?.contractorsWithGuests])
      setShowGuestsDialog(false)
      setSearchValueGuest("")
      setGuestName("")
      setGuestEmail("")
      setGuestLastNames("")
    }
  }

  const createColaborator = () => {
    if (!colaboratorEmail.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/)) {
      setErrorInEmailColaborator(true)
      setTimeout(() => {
        setErrorInEmailColaborator(false)
      }, 2000)
      return
    }
    createMember(colaboratorEmail, "collaborator")
    setOpenSecondDialogColaborator(false)
    setColaboratorEmail("")
    setColaboratorLastNames("")
    setColaboratorName("")
    setSearchValueColaborator("")
  }

  const createGuest = (id) => {
    if (teamAssigned?.contractorsWithGuests.find(item => item.id === 0)) {
      if (guestsToAdd.length === 3 || (teamAssigned?.contractorsWithGuests?.find(item => item.id === 0)?.guests?.length + guestsToAdd.length) > 3 || teamAssigned?.contractorsWithGuests?.find(item => item.id === 0)?.guests?.length === 3) {
        setMessage("Solo se permiten 3 invitados por negociación")
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 2000)
        return
      }
    } else {
      if (guestsToAdd.length === 3 || (teamAssigned?.contractorsWithGuests?.find(item => item.contractorId === id)?.guests?.length + guestsToAdd.length) > 3 || teamAssigned?.contractorsWithGuests?.find(item => item.contractorId === id)?.guests?.length === 3) {
        setMessage("Solo se permiten 3 invitados por negociación")
        setError(true)
        setTimeout(() => {
          setError(false)
        }, 2000)
        return
      }
    }
    if (!guestEmail.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,10}$/)) {
      setErrorInEmail(true)
      setTimeout(() => {
        setErrorInEmail(false)
      }, 2000)
      return
    }
    createMember(guestEmail, "guest", id)
    setOpenSecondDialogGuest(false)
    setGuestEmail("")
    setGuestName("")
    setGuestLastNames("")
    setSearchValueGuest("")
  }

  const addColaborators = () => {
    setShowColaboratorDialog(false)
    addTeamMember(colaboratorsToAdd, "collaborator")
    setColaboratorsToAdd([])
  }

  const addGuests = (id) => {
    setShowGuestsDialog(false)
    addTeamMember(guestsToAdd, 'guest', id)
    setGuestsToAdd([])
    setSearchValueColaborator("")
    setSearchValueGuest("")
  }

  useEffect(() => {
    if (!teamAssigned?.ownTeam) {
      return
    } else {
      const usersCopy = [...originalArrayColaborator]
      const dataUpdate = usersCopy.filter((item) => {
        return (
          item.fullName.toLowerCase().includes(searchValueColaborator.toLowerCase()) ||
          item.email.toLowerCase().includes(searchValueColaborator.toLowerCase())
        );
      });
      setFilteredArrayColaborator(dataUpdate);
    }
  }, [searchValueColaborator]);

  useEffect(() => {
    if (!teamAssigned?.ownTeam) {
      return
    } else {
      const usersCopy = [...originalArrayGuest]
      if (teamAssigned.contractorsWithGuests.find(item => item.id === 0)) {
        const dataUpdate = usersCopy.filter((item) => {
          return (
            item.email.toLowerCase().includes(searchValueGuest.toLowerCase())
          );
        });
        setFilteredArrayGuest(dataUpdate);
      } else {
        const dataUpdate = usersCopy.filter((item) => {
          return (
            item.emailContractor.toLowerCase().includes(searchValueGuest.toLowerCase()) || item.name.toLowerCase().includes(searchValueGuest.toLowerCase())
          );
        });
        setFilteredArrayGuest(dataUpdate);
      }
    }
  }, [searchValueGuest]);

  useEffect(() => {
    if (!teamAssigned?.ownTeam) {
      return
    } else {
      if (teamAssigned.contractorsWithGuests.find(item => item.id === 0)) {
        const originalArrayGuest = [...teamAssigned?.contractorsWithGuests.find(item => item.id === 0).possibleGuests]
        if (guestsToAdd.length > 0) {
          for (let i = 0; i < guestsToAdd.length; i++) {
            const indexArray = originalArrayGuest.findIndex(item => item.id === guestsToAdd[i].id)
            originalArrayGuest[indexArray] = {
              ...originalArrayGuest[indexArray],
              isAssigned: true
            }
          }
        }
        setOriginalArrayGuest(originalArrayGuest)
        setFilteredArrayGuest(originalArrayGuest)
      } else {
        const originalArrayGuest = [...teamAssigned?.contractorsWithGuests]
        if (guestsToAdd.length > 0) {
          for (let i = 0; i < guestsToAdd.length; i++) {
            const indexArray = originalArrayGuest.findIndex(item => item.id === guestsToAdd[i].id)
            originalArrayGuest[indexArray] = {
              ...originalArrayGuest[indexArray],
              isAssigned: true
            }
          }
        }
        setOriginalArrayGuest(originalArrayGuest)
        setFilteredArrayGuest(originalArrayGuest)
      }
      const originalArray = [...teamAssigned.ownTeam.possibleCollaborators]
      if (colaboratorsToAdd.length > 0) {
        for (let i = 0; i < colaboratorsToAdd.length; i++) {
          const indexArray = originalArray.findIndex(item => item.id === colaboratorsToAdd[i].id)
          originalArray[indexArray] = {
            ...originalArray[indexArray],
            isAssigned: true
          }
        }
      }
      setOriginalArrayColaborator(originalArray)
      setFilteredArrayColaborator(originalArray)
    }
  }, [teamAssigned])

  const cellColumnOne = (props) => {
    return (
      <td className="dialogNegotiation-cell-one">
        <div className="dialogNegotiation-cell-one-div">
          <div className="text-double">
            <span className="dialogNegotiation-containerLabel">
              {props.dataItem.fullName}
            </span>
            <span className="dialogNegotiation-containerLabel" style={{ fontWeight: 400 }}>
              {props.dataItem.email}
            </span>
          </div>
          <CheckBoxHLPure
            valueCheckBox={props.dataItem}
            checkedState={props.dataItem.isAssigned}
            onChangeHandler={(e) => onChangeCheckbox(e, props.dataItem)}
          />
        </div>
      </td>
    );
  };

  const cellColumnOneGuest = (props) => {
    return (
      <td className="dialogNegotiation-cell-one">
        <div className="dialogNegotiation-cell-one-div">
          <div className="text-double">
            {!teamAssigned?.contractorsWithGuests.find(item => item.id === 0) ?
              <>
                <span className="dialogNegotiation-containerLabel">
                  {props.dataItem.name}
                </span>
                <span className="dialogNegotiation-containerLabel" style={{ fontWeight: 400 }}>
                  {props.dataItem.emailContractor}
                </span>
              </>
              :
              <>
                <span className="dialogNegotiation-containerLabel">
                  {props.dataItem.email}
                </span>
              </>}
          </div>
          <CheckBoxHLPure
            valueCheckBox={props.dataItem}
            checkedState={props.dataItem.isAssigned}
            onChangeHandler={(e) => onChangeCheckboxGuest(e, props.dataItem)}
          />
        </div>
      </td>
    );
  };
  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '45px' }}>
        <Grid item xs={6} style={{ alignSelf: 'center' }}>
          <div style={{ textAlign: 'center' }}>
            {showColaboratorDialog &&
              <DialogUserNegotiation
                errorInEmail={errorInEmailColaborator}
                titleDialog2={t("negotiation.view.modal.title.newCollaborator")}
                createMember={() => createColaborator()}
                inputName={colaboratorName}
                inputNameChange={(e) => setColaboratorName(e.target.value)}
                inputLastName={colaboratorLastNames}
                inputLastNameChange={(e) => setColaboratorLastNames(e.target.value)}
                inputEmail={colaboratorEmail}
                inputEmailChange={(e) => setColaboratorEmail(e.target.value)}
                titleDialog={t("negotiation.view.title.addTrader")}
                nameAddBtn={t("negotiation.view.button.addCollaborator")}
                openSecondDialog={openSecondDialogColaborator}
                setOpenSecondDialog={() => setOpenSecondDialogColaborator(!openSecondDialogColaborator)}
                dataUsers={filteredArrayColaborator}
                searchValue={searchValueColaborator}
                setSearchValue={(e) => setSearchValueColaborator(e.target.value)}
                handleSubmit={() => addColaborators()}
                cancel={() => closeColaboratorDialog()}
                cellColumnOne={cellColumnOne}
                searchPlaceholder={t("negotiation.view.placeholder.searchCollaborators")}
              />
            }
          </div>
          <ButtonHLPure
            nameBtn={t("negotiation.view.button.addCollaborator")}
            primary={true}
            onClickBtn={() => setShowColaboratorDialog(true)}
            style={{ margin: 'auto', marginTop: '15px' }}
          />
        </Grid>
        <Grid item xs={6}>
          <GridHLPure
            dataGrid={
              teamAssigned ? teamAssigned.ownTeam ? teamAssigned.ownTeam.usersAndCollabs : []
                : []
            }
            skip={0}
            take={3}
            titleRow1={t("negotiation.view.grid.teamMembers")}
            titleRow3={t("digitalContractTemlates.titleGrid2")}
            titleRow4={t("digitalContractTemlates.titleGrid3")}
            // Important properties
            fieldRow1Path={"user"}
            fieldRow1={"fullName"}
            fieldRow1PathDefault={"email"}
            fieldRowSubtitlePath={"workflowExecutionMemberType"}
            fieldSubtitle={"name"}
            // ------------------
            onFilterChange={() => { }}
            status={"active"}
            onSelectedItem={props.setSelectedItem}
            setShowDetails={() => { }}
            setNameComponentUser={() => { }}
            filter={true}
            iconOneActions={bussiness}
            iconTwoActions={disable}
            labelThirdActions={t("negotiation.view.title.variables")}
            labelFourthActions={t("button.delete")}
            column2Status={false}
            columnThree={false}
            columnFour={true}
            iconColumnTwo={false}
            iconActiveTwo={false}
            iconColumnThree={false}
            iconOptionOne={iconTemplateSet}
            iconOptionThree={iconTemplateUnset}
            iconOneActive={false}
            iconStatus={'documentLoaded'}
            iconTwoActive={false}
            iconActiveThree={false}                               // 
            iconThirdActive={false}
            iconFourthActive={true}
            iconAvatar={false}
            styleCol1={'digitalContractTemplates-cellItemStyleCol1'}
            styleCol3={'digitalContractTemplates-cellItemStyleCol3'}
            // styleCol4={'digitalContractTemplates-cellItemStyleCol4'}
            minHeight={'337px'}
            styleGrid={{ width: '90%' }}
          />
        </Grid>
        {
          teamAssigned?.contractorsWithGuests ? teamAssigned?.contractorsWithGuests?.length > 0 ?
            teamAssigned?.contractorsWithGuests.map((contractor, key) => (
              <>
                <Grid item xs={6} style={{ alignSelf: 'center', textAlign: 'center' }}>
                  <div style={{ textAlign: 'center' }}>
                    {showGuestDialog && (
                      <DialogUserNegotiation
                        createMember={() => createGuest(contractor.contractorId)}
                        errorInEmail={errorInEmail}
                        inputName={guestName}
                        descriptionActive
                        inputNameChange={(e) => setGuestName(e.target.value)}
                        inputLastName={guestLastNames}
                        inputLastNameChange={(e) => setGuestLastNames(e.target.value)}
                        inputEmail={guestEmail}
                        inputEmailChange={(e) => setGuestEmail(e.target.value)}
                        openSecondDialog={openSecondDialogGuest}
                        setOpenSecondDialog={() => setOpenSecondDialogGuest(!openSecondDialogGuest)}
                        titleDialog2={t("negotiation.view.modal.title.newGuest")}
                        cancel={() => closeGuestsDialog()}
                        dataUsers={filteredArrayGuest}
                        cellColumnOne={cellColumnOneGuest}
                        titleDialog={t("negotiation.view.modal.title.addTrader")}
                        nameAddBtn={t("negotiation.view.modal.button.addGuest")}
                        setSearchValue={(e) => setSearchValueGuest(e.target.value)}
                        handleSubmit={() => addGuests(contractor.contractorId)}
                        searchPlaceholder={t("negotiation.view.modal.placeholder.searchGuest")}
                      />
                    )
                    }
                  </div>
                  <ButtonHLPure
                    nameBtn={t("negotiation.view.modal.button.addGuest")}
                    primary={true}
                    // onClickBtn={() => {
                    //   addTeamMember(autoCompleteGuests.current[key]._input.value, 'guest', contractor.contractorId)
                    // }}
                    onClickBtn={() => setShowGuestsDialog(true)}
                    style={{ margin: 'auto', marginTop: '15px' }}
                  />
                </Grid>
                <Grid item xs={6} style={{ marginBottom: '65px', alignSelf: 'center' }}>
                  <GridHLPure
                    pageable={false}
                    dataGrid={contractor.guests ? contractor.guests : []}
                    skip={0}
                    take={3}
                    titleRow1={`${t("negotiation.view.grid.teamParticipantsUser")} ${contractor.contractorName}`}
                    titleRow3={t("digitalContractTemlates.titleGrid2")}
                    titleRow4={t("digitalContractTemlates.titleGrid3")}
                    fieldRow1Path={"user"}
                    fieldRow1={"fullName"}
                    fieldRow1PathDefault={"email"}
                    fieldRowSubtitlePath={"workflowExecutionMemberType"}
                    fieldSubtitle={"name"}
                    onFilterChange={() => { }}
                    status={"active"}
                    onSelectedItem={props.setSelectedItem}
                    setShowDetails={() => { }}
                    setNameComponentUser={() => { }}
                    filter={true}
                    iconOneActions={bussiness}
                    iconTwoActions={disable}
                    labelThirdActions={t("negotiation.view.title.variables")}
                    labelFourthActions={t("button.delete")}
                    column2Status={false}
                    columnThree={false}
                    columnFour={true}
                    iconColumnTwo={false}
                    iconActiveTwo={false}
                    iconColumnThree={false}
                    iconOptionOne={iconTemplateSet}
                    iconOptionThree={iconTemplateUnset}
                    iconOneActive={false}
                    iconStatus={'documentLoaded'}
                    iconTwoActive={false}
                    iconActiveThree={false}
                    iconThirdActive={false}
                    iconFourthActive={true}
                    iconAvatar={false}
                    styleCol1={'digitalContractTemplates-cellItemStyleCol1'}
                    styleCol3={'digitalContractTemplates-cellItemStyleCol3'}
                    minHeight={'0'}
                    styleGrid={{ width: '90%' }}
                  />
                </Grid>
              </>
            )) : null : null
        }
      </Grid>
    </>
  );
}

export { TeamNegotiationView as default };